// VALOR_EDITAVEL_2810 (GROK2): valor em R$ editável no Renovar/Criar rápido -> venda no Financeiro.
// Não mexe em créditos. Switch: private/VALOR_EDITAVEL_2810_OFF.
import axios from 'axios';
import { API_BASE_URL } from '../apiBase';

export function planPriceBRL2810(p) {
  const raw = p?.price ?? p?.price_brl ?? p?.valor ?? '';
  const n = Number(String(raw).replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.'));
  return Number.isFinite(n) && n > 0 ? n.toFixed(2).replace('.', ',') : '';
}

// VALOR_PARSE_2810: "30.50" virava 3050. Agora: com vírgula = formato BR (1.234,56); só ponto = decimal.
export function parseValor2810(amount) {
  const t = String(amount ?? '').trim();
  if (!t) return NaN;
  if (t.includes(',')) return Number(t.replace(/\./g, '').replace(',', '.'));
  if (/^\d{1,3}(\.\d{3})+$/.test(t)) return Number(t.replace(/\./g, ''));
  return Number(t);
}

export async function registrarVenda2810({ amount, kind, username, lineId, planLabel, requestId }) {
  const v = parseValor2810(amount);
  if (!Number.isFinite(v) || v <= 0) return null;
  const { data } = await axios.post(`${API_BASE_URL}/api/aurax/valor-venda`, {
    amount: v, kind, username, line_id: lineId || '', plan_label: planLabel || '', request_id: requestId || '',
  }, { withCredentials: true, timeout: 20000 });
  return data;
}
